export default __webpack_public_path__ + "static/media/map.7de71714.png";